import { render, staticRenderFns } from "./NewBorns.vue?vue&type=template&id=57aed433&scoped=true&"
import script from "./NewBorns.vue?vue&type=script&lang=js&"
export * from "./NewBorns.vue?vue&type=script&lang=js&"
import style0 from "./NewBorns.vue?vue&type=style&index=0&id=57aed433&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57aed433",
  null
  
)

export default component.exports